<template>
	<div>
		<label class="v-label mb-0" :class="{'dense-label': dense }">
			<Label :param="param"></Label>
		</label>

		<div :class="dense ? 'grv-input-dense' : 'grv-input'">
			<codeEditor
				id=""
				:value="value"
				@input="$emit('update:value', $event)"
				:name="param.name"
				lang="json"
				theme="monokai"
				:options="options"
				@init="editorInit($event)">
			</codeEditor>
		</div>

		<Hint :param="param"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		codeEditor: require('vue2-ace-editor'),
		Hint
	},
	data () {
		return {
			rules: [],
			editor: null,
			fold_level: 2,
			options: {
				readOnly: this.readonly,
				maxLines: 30,
				minLines: 3,
				fontSize: '16pt',
				printMargin: false,
				wrap: true,
				autoScrollEditorIntoView: false
			}
		}
	},
	methods: {
		editorInit: function (editor) {
			this.editor = editor
			require('brace/theme/ambiance') //
			require('brace/theme/chaos')
			require('brace/theme/chrome')
			require('brace/theme/clouds')
			require('brace/theme/clouds_midnight')
			require('brace/theme/cobalt')
			require('brace/theme/crimson_editor')
			// require('brace/theme/dawn')
			// require('brace/theme/dracula')
			// require('brace/theme/dreamweaver')
			// require('brace/theme/eclipse')
			// require('brace/theme/github')
			// require('brace/theme/gob')
			// require('brace/theme/gruvbox')
			// require('brace/theme/idle_fingers')
			// require('brace/theme/iplastic')
			// require('brace/theme/katzenmilch')
			// require('brace/theme/kr_theme')
			// require('brace/theme/kuroir')
			// require('brace/theme/merbivore')
			// require('brace/theme/merbivore_soft')
			// require('brace/theme/mono_industrial')
			// require('brace/theme/pastel_on_dark')
			// require('brace/theme/solarized_dark')
			// require('brace/theme/solarized_light')
			// require('brace/theme/sqlserver')
			// require('brace/theme/terminal')
			// require('brace/theme/textmate')
			// require('brace/theme/tomorrow')
			// require('brace/theme/tomorrow_night')
			// require('brace/theme/tomorrow_night_blue')
			// require('brace/theme/tomorrow_night_bright')
			// require('brace/theme/tomorrow_night_eighties')
			// require('brace/theme/twilight')
			// require('brace/theme/vibrant_ink')
			// require('brace/theme/xcode')
			require('brace/mode/json')
			require('brace/snippets/json')
			require('brace/theme/monokai')
			require('brace/ext/language_tools')
			require('brace/ext/searchbox')
			require('brace/ext/beautify')
			this.$nextTick(() => {
				editor.session.foldAll()
				let folds
				for (var i = 0; i < this.fold_level; i++) {
					folds = editor.session.getAllFolds()
					if (folds.length === 0) break
					editor.session.expandFolds(folds)
				}
			})
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>

<style scoped lang="stylus">
.ace_editor.ace-monokai.ace_dark
	margin-bottom: 8px
	background-color: rgba(0, 0, 0, 0.15) !important
	border: 0.5px solid var(--v-background-lighten2) !important
	border-radius: 2px
	font-size: 16px !important
	>>>.ace_gutter
		background-color: var(--v-background-darken2) !important
		border-right: 0.5px solid var(--v-background-lighten2) !important
		z-index: 3
		>>>.ace_gutter-cell
			padding-right: 10px !important
		.ace_fold-widget
			transform: scale(1.5) !important
	>>>.ace_selected-word
		border: 1px solid #ffe800
	>>>.ace_active-line
	>>>.ace_gutter-active-line
		background-color: inherit
	>>>.ace_scroller
		background-color: transparent
		box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 10px 5px inset

>>>.ace_search
>>>.ace_search_field
>>>.ace_searchbtn
	border-color: var(--v-background-lighten3)
	color: white

>>>.ace_search
>>>.ace_search_options > *
	color: white
	background-color: var(--v-background-base)

>>>.ace_searchbtn_close
	background-color: white

>>>.ace_search_form
>>>.ace_replace_form
	*
		background-color: var(--v-background-darken1)

::-webkit-scrollbar
::-webkit-scrollbar-track-piece
	background-color: var(--v-background-darken1) !important

.v-label
	color: var(--v-background-lighten4)
.v-label.dense-label
	font-size: 14px
	position: relative
	bottom: -4px

.append-slot
	width: 24px
	position: relative
	bottom: -8px
</style>



// WEBPACK FOOTER //
// src/components/fields/json.vue